import { axios } from '@/services/axios';

export const postVg = (data) => axios.post('/VisibilityGroup', data);
